import { ActionsUnion, createAction } from "@bookingcom/flights-core";
import { UIClientFetchError, UIFlightData } from "@flights/types";

export enum ActionTypes {
  fetch = "metaFlightDetails/fetch",
  fetchSuccess = "metaFlightDetails/fetchSuccess",
  fetchError = "metaFlightDetails/fetchError"
}

export const actions = {
  fetch: createAction(() => ({
    type: ActionTypes.fetch,
    payload: {}
  })),

  fetchSuccess: createAction((flight: UIFlightData) => ({
    type: ActionTypes.fetchSuccess,
    payload: { flight }
  })),

  fetchError: createAction((error: UIClientFetchError) => ({
    type: ActionTypes.fetchError,
    payload: { error }
  }))
};

export type Actions = ActionsUnion<typeof actions>;
